import { useDispatch } from 'react-redux';

import MapPage from '../../components/Pages/MapPage';
import { clearedData } from '../actions';
import { serviceTypes } from '../initData/services';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function MapPageWrapper({
  serviceId,
  cityId,
  ageId,
  robotId,
  hideSuggestButton,
  '*': restUrl,
}) {
  const dispatch = useDispatch();
  const shouldBePage = pages.map;

  const isWorkshopService = serviceId === serviceTypes.workshop;
  const isSummerplayService = serviceId === serviceTypes.summerplay;
  const isAcademyService = serviceId === serviceTypes.academy;
  const isOneTimeWorkshopService = serviceId === serviceTypes.one_time_workshop;
  let conditionTypes = {
    page: true,
    service: true,
    franchise: true,
    age: isWorkshopService,
    robot: isWorkshopService,
    workshops: isWorkshopService,
    summerplays: isSummerplayService,
    academies: isAcademyService,
    one_time_workshops: isOneTimeWorkshopService,
  };

  let locationId = undefined;
  let occurrenceId = undefined;

  if (restUrl) {
    // locationId and occurrenceId
    conditionTypes.location = true;
    const indexOfSlash = restUrl.search('/'); // between locationId and occurrenceId
    occurrenceId =
      indexOfSlash !== -1 &&
      restUrl.substring(indexOfSlash + 1, restUrl.length);

    if (occurrenceId) {
      conditionTypes.occurrence = true;
      locationId = restUrl.substring(0, indexOfSlash);
    } else {
      locationId = restUrl;
    }
  } else {
    dispatch(clearedData('state', 'locationId'));
    dispatch(clearedData('state', 'occurrence'));
  }

  return (
    <PageWrapper
      pageToLoad={<MapPage hideSuggestButton={hideSuggestButton} />}
      shouldBePage={shouldBePage}
      serviceId={serviceId}
      cityId={cityId}
      ageId={ageId}
      robotId={robotId}
      locationId={locationId}
      occurrenceId={occurrenceId}
      conditions={conditionTypes}
    />
  );
}
